/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line







  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();




        
        
var swiper = new Swiper(".swiper-container", {
  loop: true,
    autoplay: {
        delay: 3000, // 3000 milliseconds = 3 seconds
        disableOnInteraction: false, // Keep autoplay running even when user interacts
        pauseOnMouseEnter: true, // Pauses autoplay when the mouse hovers over the slider
    },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });